/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GeoLocationEntity } from './geoLocationEntity';

export interface CreateGroupDto {
  /**
   * Allow activities to invite this group as a share target.
   */
  allowActivitySharing?: boolean;
  handiFriendly?: boolean;
  name: string;
  location?: GeoLocationEntity;
  parentGroupId?: string;
  sportId: string;
  /**
   * SMA-99. Added by hand like the other two: `generate:sdk` needs a running
   * API, and the offline export does not carry this model.
   */
  sportIds?: Array<string>;
  privacy: CreateGroupDto.PrivacyEnum;
  rightCreateActivity: CreateGroupDto.RightCreateActivityEnum;
  description: string;
  backgroundUrl?: string;
  websiteUrl?: string;
}
export namespace CreateGroupDto {
  export type PrivacyEnum = 'public' | 'private' | 'hidden';
  export const PrivacyEnum = {
    Public: 'public' as PrivacyEnum,
    Private: 'private' as PrivacyEnum,
    Hidden: 'hidden' as PrivacyEnum,
  };
  export type RightCreateActivityEnum = 'allMembers' | 'onlyAdmin';
  export const RightCreateActivityEnum = {
    AllMembers: 'allMembers' as RightCreateActivityEnum,
    OnlyAdmin: 'onlyAdmin' as RightCreateActivityEnum,
  };
}
